import { LayingType, LayingTypeLabel } from 'pages/common/components/LayingTypeField/const';
import { LaminateInputs } from '../../../types';
import { parametersGALabels } from '../../../const';
import { RoomTypeLabel } from '../../../components/RoomsParams/room-type-field/const';

const PARAMS_SEPARATOR = '/';

export const getGaSubmitLaminateProjectElementVariant = (inputsData: LaminateInputs) => {
  const isAreaSelected = Boolean(inputsData.area);
  const resultValues = [];
  resultValues.push(`${parametersGALabels.roomType} - ${RoomTypeLabel[inputsData.roomType]}`);
  if (isAreaSelected) {
    resultValues.push(`${parametersGALabels.area} - ${inputsData.area}`);
  } else {
    resultValues.push(`${parametersGALabels.lengthAndWidth} - ${inputsData.length} х ${inputsData.width}`);
  }
  if (inputsData.layingType) {
    resultValues.push(
      `${parametersGALabels.layingType} - ${LayingTypeLabel[inputsData.layingType as LayingType]}`
    );
  }

  return resultValues.join(` ${PARAMS_SEPARATOR} `);
};
